import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { useGetAssignmentsQuery } from "@features/assignments/assignmentsApi";
import { useGetQuizzesQuery } from "@features/quizzes/quizzesApi";
import { useGetAssignmentMarksQuery } from "@features/assignmentMarks/assignmentMarksApi";
import { useGetQuizMarksQuery } from "@features/quizMarks/quizMarksApi";
import useGetUserData from "@common/hooks/useGetUserData";
import AssignmentModal from "../Modal/AssignmentModal";

const Description = ({ video }) => {
  const { id, title, description, createdAt } = video || {};

  const [hasAssignment, setHasAssignment] = useState(false);
  const [hasQuiz, setHasQuiz] = useState(false);

  const [isAssignmentSubmit, setIsAssignmentSubmit] = useState(false);
  const [isQuizSubmit, setIsQuizSubmit] = useState(false);

  const { data: assignments } = useGetAssignmentsQuery() || [];

  const { data: assignmentMarks } = useGetAssignmentMarksQuery() || [];

  const { data: quizMarks } = useGetQuizMarksQuery() || [];

  const { data: quizzes } = useGetQuizzesQuery() || [];

  const { id: userId } = useGetUserData();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  function closeModal() {
    setIsModalOpen(false);
  }

  useEffect(() => {
    const assignmentWithVideo =
      assignments?.filter((a) => a.video_id === id) || [];
    const quizWithVideo = quizzes?.filter((q) => q.video_id === id) || [];

    const assignmentSubmitted = assignmentMarks?.filter(
      (item) =>
        item.student_id === userId &&
        item.assignment_id === assignmentWithVideo[0]?.id
    );

    const quizSubmitted = quizMarks?.filter(
      (item) => item.student_id === userId && item.video_id === id
    );

    setHasAssignment(assignmentWithVideo?.length > 0);
    setHasQuiz(quizWithVideo?.length > 0);

    setIsAssignmentSubmit(assignmentSubmitted?.length > 0);
    setIsQuizSubmit(quizSubmitted?.length > 0);
  }, [
    id,
    userId,
    assignments,
    quizzes,
    assignmentMarks,
    quizMarks,
    setHasAssignment,
    setHasQuiz,
    setIsQuizSubmit,
  ]);

  const handleClick = (e) => {
    if (isQuizSubmit) {
      e.preventDefault();
    }
  };

  return (
    <>
      {id && (
        <div>
          <h1 className="text-lg font-semibold tracking-tight text-slate-100">
            {title}
          </h1>
          <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
            Uploaded on{" "}
            {createdAt &&
              format(
                utcToZonedTime(new Date(createdAt), "Asia/Dhaka"),
                "dd MMMM yyyy",
                {
                  timeZone: "Asia/Dhaka",
                }
              )}
          </h2>

          <div className="flex gap-4">
            {hasAssignment && (
              <button
                onClick={openModal}
                disabled={isAssignmentSubmit}
                className={`px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary ${
                  isAssignmentSubmit
                    ? "cursor-not-allowed bg-cyan text-dark"
                    : "cursor-pointer text-cyan"
                }`}
              >
                {isAssignmentSubmit ? "এসাইনমেন্ট জমা দিয়েছেন" : "এসাইনমেন্ট"}
              </button>
            )}

            {hasQuiz && (
              <Link
                to={`/quiz/${id}`}
                className={`px-3 font-bold py-1 border border-cyan rounded-full text-sm hover:bg-cyan hover:text-primary ${
                  isQuizSubmit
                    ? "cursor-not-allowed bg-cyan text-dark"
                    : "cursor-pointer text-cyan"
                }`}
                onClick={handleClick}
              >
                {isQuizSubmit ? "কুইজে অংশগ্রহণ করেছেন" : "কুইজে অংশগ্রহণ করুন"}
              </Link>
            )}
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
        </div>
      )}
      <AssignmentModal
        videoId={id}
        videoTitle={title}
        open={isModalOpen}
        closeModal={closeModal}
      />
    </>
  );
};

export default Description;
